import { useFetchData } from '@/helpers/hooks';

import { GuideContextSummary } from './guide.types';

export const useGuideContext = (pathname: string, strategyId?: string, enabled = true) => {
  const params = new URLSearchParams({ routeKey: pathname });
  if (strategyId) params.set('strategyId', strategyId);

  return useFetchData<GuideContextSummary>(
    ['weavrGuideContext', pathname, strategyId],
    `/Guide/Context?${params.toString()}`,
    {
      enabled,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: false
    }
  );
};
